module.exports = __webpack_public_path__ + "img/11_15.6a204dda.png";